import { useEffect, useState } from "react";
import { getAllCategories } from "../api/categoryApi";
import { SearchableSelect } from "./SearchableSelect";

export const CategorySelect = ({ value, onChange, error }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState("");

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    setLoading(true);
    setFetchError("");

    try {
      const response = await getAllCategories();

      if (response.success) {
        setCategories(response.categories);
      } else {
        setFetchError("Failed to load categories");
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      setFetchError("Failed to load categories");
    } finally {
      setLoading(false);
    }
  };

  const handleCategoryChange = (categoryId) => {
    const selectedCategory = categories.find(cat => cat._id === categoryId);

    if (onChange && selectedCategory) {
      onChange({
        _id: selectedCategory._id,
        name: selectedCategory.name
      });
    }
  };

  // Get the current value for display
  const getCurrentValue = () => {
    if (!value) return "";
    
    // If value is just an ID string
    if (typeof value === 'string') {
      return value;
    }
    
    // If value is an object with _id
    return value._id || "";
  };

  return (
    <SearchableSelect
      options={categories}
      value={getCurrentValue()}
      onValueChange={handleCategoryChange}
      placeholder="Select a category"
      searchPlaceholder="Search categories..."
      loading={loading}
      error={error || fetchError}
      formatOption={(category) => category.name}
      getValue={(category) => category._id}
      emptyMessage="No categories found"
    />
  );
};